import {
  show_detail_default
} from "../../chunk-MGQRGJ3A.js";
import "../../chunk-C3SCZNET.js";
import "../../chunk-MWWKBSGI.js";
import "../../chunk-BDMS7HSP.js";
import "../../chunk-IR27FJG7.js";
import "../../chunk-JSBRDJBE.js";
export {
  show_detail_default as default
};
